import { ref, VueElement } from "vue";
import { defineStore } from "pinia";

export default defineStore("state", () => {
  const isLoading = ref(false);
  const instances = ref<Record<string, IInstance>>({});

  const initInstance = (id: string) => {
    instances.value[id] = {
      entries: undefined,
      pagination: undefined,
      filters: undefined
    };
  }

  const addInstance = (id: string, type: IInstanceType, instance: VueElement) => {
    // if instance does not exist, create it first
    if (!instances.value[id]) {
      initInstance(id);
    }

    // add instance
    instances.value[id][type] = instance;
  }

  const removeInstance = (id: string, type: IInstanceType) => {
    if (instances.value[id]) {
      delete instances.value[id][type];
    }
  }

  return {
    isLoading,
    instances,
    addInstance,
    removeInstance
  };
});
